import {
  getAreaList,
  saveAreaAPI,
  deleteAreaAPI,
  getAreaListCombo
} from '../../../services/Masters/MatersService';

export const fetchAreas = async (statusGUID) => {
  try {
    const response = await getAreaList(statusGUID);

    if (response && response.success) {
      return response.returnResult || [];
    } else {
      window.showSnackbar({
        message: response?.message || 'An error occurred while fetching Areas',
        variant: 'error'
      });
      console.log('Error fetching Areas:', response?.message);
      return [];
    }
  } catch (err) {
    window.showSnackbar({
      message: err.message || 'An error occurred while fetching Areas',
      variant: 'error'
    });
    console.log('Error fetching Areas:', err);
    return [];
  }
};

export const fetchAreaListCombo = async () => {
  try {
    const response = await getAreaListCombo();

    if (response && response.success) {
      return response.returnResult || [];
    } else {
      window.showSnackbar({
        message: response?.message || 'An error occurred while fetching Areas combo',
        variant: 'error'
      });
      console.log('Error fetching Areas combo:', response?.message);
      return [];
    }
  } catch (err) {
    window.showSnackbar({
      message: err.message || 'An error occurred while fetching Areas combo',
      variant: 'error'
    });
    console.log('Error fetching Areas:', err);
    return [];
  }
};

export const saveArea = async (payload, customSuccessMsg, customErrorMsg) => {
  try {
    const response = await saveAreaAPI(payload);
    if (!response || !response.success) {
      console.log('response?.message', response?.message || 'Failed to save Area');
      window.showSnackbar({
        message: customErrorMsg || `Failed to save Area`,
        variant: 'error'
      });
    } else {
      window.showSnackbar({
        message: customSuccessMsg || `Area saved successfully`,
        variant: 'success'
      });
    }
    return response;
  } catch (err) {
    const errorMessage = err?.message || (typeof err === 'string' ? err : 'Failed to save Area');
    window.showSnackbar({
      message: errorMessage,
      variant: 'error'
    });
    console.log('Failed to save Area:', err);
    return { success: false, message: errorMessage };
  }
};

export const deleteArea = async (AreaGUID, customSuccessMsg, customErrorMsg) => {
  try {
    const response = await deleteAreaAPI(AreaGUID);
    if (!response || !response.success) {
      console.log('response?.message', response?.message || 'Failed to delete Area');
      window.showSnackbar({
        message: customErrorMsg || `Failed to delete Area`,
        variant: 'error'
      });
    } else {
      window.showSnackbar({
        message: customSuccessMsg || `Area deleted successfully`,
        variant: 'success'
      });
    }
    return response;
  } catch (err) {
    const errorMessage = err?.message || (typeof err === 'string' ? err : 'Failed to delete Area');
    window.showSnackbar({
      message: errorMessage,
      variant: 'error'
    });
    console.log('Failed to delete Area:', err);
    return { success: false, message: errorMessage };
  }
};
